import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import FI1 from '../../assets/img/fi1.png';
import FI2 from '../../assets/img/fi2.svg';
import FI3 from '../../assets/img/fi3.png';
import FI4 from '../../assets/img/fi4.svg';
import FI5 from '../../assets/img/fi5.png';
import FI6 from '../../assets/img/fi6.png';

import SL1 from '../../assets/img/support1.jpg';
import SL2 from '../../assets/img/support2.jpg';
import SL3 from '../../assets/img/spreeha.jpg';
import SL4 from '../../assets/img/support4.jpeg';

import { AuthContext } from '../../context/AuthContext';

const FALLBACK_SUPPORT = [
  { name: 'Accelerating Asia', image: SL1, className: '' },
  { name: 'Startup Bangladesh', image: SL2, className: 's-b' },
  { name: 'Spreeha', image: SL3, className: 's-p' },
  { name: 'IIX', image: SL4, className: '' },
];

const FALLBACK_FEATURED = [
  { name: 'Prothom Alo', image: FI1, className: '' },
  { name: 'The Daily Star', image: FI2, className: 'daily-star' },
  { name: 'Channel i', image: FI3, className: '' },
  { name: 'Dhaka Tribune', image: FI4, className: 'dhaka-tribun' },
  { name: 'The Business Standard', image: FI5, className: '' },
  { name: 'New Age', image: FI6, className: 'new-adge' },
];

const getSupporterClass = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('startup')) return 's-b';
  if (n.includes('spreeha')) return 's-p';
  return '';
};

const getFeaturedClass = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('daily star')) return 'daily-star';
  if (n.includes('tribune')) return 'dhaka-tribun';
  if (n.includes('new age')) return 'new-adge';
  return '';
};

const FeaturedIn = () => {
  const { postActivity } = useContext(AuthContext);
  const [supportList, setSupportList] = useState([]);
  const [featuredList, setFeaturedList] = useState([]);

  useEffect(() => {
    // Fetch Supported By
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/press/banner-get/?banner_type=supported-by&is_active=true&ordering=sorting&limit=20`
      )
      .then((resp) => {
        if (resp.data?.results && resp.data.results.length > 0) {
          setSupportList(resp.data.results);
        }
      })
      .catch(() => {});

    // Fetch Featured In
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/press/banner-get/?banner_type=featured-in&is_active=true&ordering=sorting&limit=50`
      )
      .then((resp) => {
        if (resp.data?.results && resp.data.results.length > 0) {
          setFeaturedList(resp.data.results);
        }
      })
      .catch(() => {});
  }, []);

  const supporters = supportList && supportList.length > 0 ? supportList : FALLBACK_SUPPORT;
  const rawFeatured = featuredList && featuredList.length > 0 ? featuredList : FALLBACK_FEATURED;
  // Repeat for continuous marquee
  const marqueeFeatured = [...rawFeatured, ...rawFeatured, ...rawFeatured, ...rawFeatured];

  return (
    <section className='sponsor featured'>
      <div className='container support-by'>
        <div className='row'>
          <div className='col-12'>
            <h5 className='section-heading text-center'>Supported By</h5>
          </div>
          <div
            className='col-12'
            onClick={() =>
              postActivity('box', 'Featured In Logo', window.location.href)
            }
          >
            <div className='images desktop-d'>
              {supporters.map((item, i) => (
                <img
                  key={item.id || i}
                  src={item.image}
                  title={item.name}
                  alt={item.name}
                  className={item.className || getSupporterClass(item.name)}
                />
              ))}
            </div>
            <marquee className='images mobile-d'>
              {supporters.map((item, i) => (
                <img
                  key={item.id || i}
                  src={item.image}
                  title={item.name}
                  alt={item.name}
                  className={item.className || getSupporterClass(item.name)}
                />
              ))}
            </marquee>
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <h5 className='section-heading text-center'>Featured In</h5>
          </div>
          <div
            className='col-12'
            onClick={() =>
              postActivity('box', 'Featured In Logo', window.location.href)
            }
          >
            <marquee className='images'>
              {marqueeFeatured.map((item, i) => (
                <img
                  key={i}
                  src={item.image}
                  alt={item.name || ''}
                  className={item.className || getFeaturedClass(item.name)}
                />
              ))}
            </marquee>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedIn;
